import React from 'react'
import { motion } from 'framer-motion'

const LoadingSpinner = ({ message = "Cargando...", size = "medium", fullScreen = true }) => {
  const sizeClasses = {
    small: "w-8 h-8",
    medium: "w-12 h-12",
    large: "w-16 h-16"
  }

  const textSizes = {
    small: "text-sm",
    medium: "text-base", 
    large: "text-lg"
  }

  const containerClass = fullScreen ? "min-h-screen flex items-center justify-center" : "flex flex-col items-center justify-center p-8"

  return (
    <div className={containerClass}>
      <div className="text-center">
        {/* Modern Spinner */}
        <div className={`relative ${sizeClasses[size]} mx-auto mb-4`}>
          {/* Outer spinning ring */}
          <motion.div
            className="absolute inset-0 rounded-full"
            style={{
              background: 'conic-gradient(from 0deg, transparent, var(--primary-500), transparent)',
            }}
            animate={{ rotate: 360 }}
            transition={{
              duration: 1,
              repeat: Infinity,
              ease: "linear"
            }}
          />
          
          {/* Inner spinning ring (opposite direction) */}
          <motion.div
            className="absolute inset-1 rounded-full"
            style={{
              background: 'conic-gradient(from 180deg, transparent, var(--primary-300), transparent)',
            }}
            animate={{ rotate: -360 }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: "linear"
            }}
          />
          
          {/* Center circle */}
          <div className="absolute inset-2 rounded-full backdrop-blur-md"
            style={{
              background: 'var(--glass-bg)',
              boxShadow: '0 0 20px rgba(99, 102, 241, 0.2)'
            }}
          />
          
          {/* Pulsing center dot */}
          <motion.div
            className="absolute inset-0 flex items-center justify-center"
            animate={{ scale: [1, 1.2, 1] }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          >
            <div className="w-2 h-2 rounded-full bg-gradient-to-r from-blue-500 to-purple-500" />
          </motion.div>
        </div>

        {/* Loading message */}
        <motion.p
          className={`${textSizes[size]} font-medium text-gray-700 mb-2`}
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        >
          {message}
        </motion.p>

        {/* Loading dots */}
        <div className="flex space-x-1 justify-center">
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              className="w-1.5 h-1.5 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full"
              animate={{ 
                scale: [1, 1.5, 1],
                opacity: [0.3, 1, 0.3]
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                delay: i * 0.2,
                ease: "easeInOut"
              }}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default LoadingSpinner